import React from 'react';

const BarChart = ({ categoryResults }) => {
  // Early return if no data
  if (!categoryResults || !categoryResults.length) {
    return null;
  }

  // Define color palette for different categories
  const categoryColors = [
    "#5cc33f", // Green
    "#d1272a", // Red
    "#9c4aa2", // Purple
    "#46abe5", // Blue
    "#f9d749", // Yellow
    "#f28c39", // Orange
    "#c0c0c0", // Gray
  ];

  // Helper function to determine score level (low, medium, high)
  const getScoreLevel = (score, maxScore) => {
    const percentage = (score / maxScore) * 100;
    if (percentage < 33) return 'Low';
    if (percentage < 66) return 'Medium';
    return 'High';
  };

  // Helper to get bar width percentage
  const getBarWidth = (score, maxScore) => {
    return (score / maxScore) * 100;
  };

  return (
    <div className="bar-chart__container w-full max-w-3xl mx-auto">
      <div className="bar-chart__bars space-y-6">
        {categoryResults.map((category, index) => {
          const scoreLevel = getScoreLevel(category.score, category.maxScore);
          const barWidth = getBarWidth(category.score, category.maxScore);
          const barColor = categoryColors[index % categoryColors.length];
          
          return (
            <div key={index} className="bar-chart__category">
              <div className="flex justify-between mb-2">
                <div className="text-gray-700 font-medium">{category.categoryName}</div>
                <div className="text-gray-700 font-bold">
                  {scoreLevel} ({category.score}/{category.maxScore})
                </div>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                <div 
                  className="h-full rounded-full" 
                  style={{ 
                    width: `${barWidth}%`,
                    backgroundColor: barColor
                  }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BarChart; 